/* @ngInject */
export default function CreateContentDownloadController(
  $stateParams,
  $translate,
  $uibModalInstance,
  AlertMessages,
  CurrentCourseManager,
  CurrentUserManager,
  CustomDownloadsManager,
  CustomDownloadsModel,
  _,
) {
  const vm = this;

  vm.CustomDownloadsManager = CustomDownloadsManager;
  vm.discussionsContentDownloadCreated = CustomDownloadsManager.data.contentDownload.some((dl) => dl.reportTitle === 'Discussions');
  vm.CurrentCourseManager = CurrentCourseManager;
  vm.teamActivityContentDownloadCreated = CustomDownloadsManager.data.contentDownload.some((dl) => (
    dl.reportTitle === $translate.instant('CUSTOM_DOWNLOADS.ACTIVITIES.TEAM_WORKSPACE_ACTIVITY', {
      aliasedTeamName: vm.CurrentCourseManager.course.teamName.singularizedTitleized,
    })
  ));
  vm.$stateParams = $stateParams;
  vm.CurrentUserManager = CurrentUserManager;
  vm.groupActivityContentDownloadCreated = vm.CustomDownloadsManager.data.contentDownload.some((dl) => (
    dl.reportTitle === $translate.instant('CUSTOM_DOWNLOADS.ACTIVITIES.GROUP_WORKSPACE_ACTIVITY', {
      aliasedGroupName: vm.CurrentCourseManager.course.groupName.singularizedTitleized,
    })
  ));
  vm.contentDownloadForm = null;
  vm.contentOption = null;
  vm.exerciseId = null;

  initialize();

  function initialize() {
    return CustomDownloadsModel.getNewContentDownload($stateParams.catalogId).then((data) => {
      vm.data = data;
      vm.data.reportType = 'content';
      vm.data.courseId = vm.CurrentCourseManager.course.id;
      vm.data.contentOptions = {
        assignment: 'Submissions',
        feedback: 'Assignment Feedback',
        discussions: 'Discussion Content',
        team_workspace_activity: $translate.instant('CUSTOM_DOWNLOADS.ACTIVITIES.TEAM_WORKSPACE_ACTIVITY', {
          aliasedTeamName: vm.CurrentCourseManager.course.teamName.capitalizedPluralized,
        }),
        group_workspace_activity: $translate.instant('CUSTOM_DOWNLOADS.ACTIVITIES.GROUP_WORKSPACE_ACTIVITY', {
          aliasedGroupName: vm.CurrentCourseManager.course.groupName.capitalizedPluralized,
        }),
        feedback_criteria: 'Video Practice Feedback',
      };
    });
  }

  vm.submitCustomReport = function () {
    vm.data.contentOption = vm.contentOption;
    if (vm.contentOption === 'feedback') {
      vm.data.feedback = {
        [vm.exerciseId]: vm.data.feedback[vm.exerciseId],
      };
      vm.data.exerciseId = vm.exerciseId;

      vm.data.title = vm.data.feedback[vm.exerciseId][0];
      vm.data.feedback[vm.exerciseId][1] = true;
    } else if (vm.contentOption === 'assignment') {
      vm.data.assignments = {
        [vm.exerciseId]: vm.data.assignments[vm.exerciseId],
      };
      vm.data.exerciseId = vm.exerciseId;

      vm.data.title = vm.data.assignments[vm.exerciseId][0];
      vm.data.assignments[vm.exerciseId][1] = true;
    } else if (vm.contentOption === 'feedback_criteria') {
      vm.data.feedbackCriteria = {
        [vm.exerciseId]: vm.data.feedbackCriteria[vm.exerciseId],
      };
      vm.data.feedbackCriteriaId = vm.exerciseId;

      vm.data.title = vm.data.feedbackCriteria[vm.exerciseId][0];
      vm.data.feedbackCriteria[vm.exerciseId][1] = true;
      vm.data = _.omit(vm.data, 'exerciseId');
    }
    CustomDownloadsModel.createContentDownload($stateParams.catalogId, {
      customReports: _.omit(vm.data, 'id', 'contentOptions'),
    }).then(() => {
      $uibModalInstance.close();
      AlertMessages.success('CUSTOM_DOWNLOADS.CREATE_REPORT.CONTENT_DOWNLOAD_SUCCESS_TITLE', 'CUSTOM_DOWNLOADS.CREATE_REPORT.SUCCESS_MESSAGE', {}, {}, 20000);
    });
  };
}
